(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["machine-card"] && !Shopify.designMode) return;
  try {
    class MachineCardGallery extends HTMLElement {
    connectedCallback() {
      this.heroImg = this.querySelector('[data-machine-hero-img]');
      this.blurImg = this.querySelector('[data-machine-blur-img]');
      this.thumbs = this.querySelectorAll('[data-machine-thumb]');
      if (!this.heroImg || this.thumbs.length === 0) return;

      const hoverEnabled = this.dataset.swap === 'hover' && window.matchMedia('(hover: hover)').matches;

      this.thumbs.forEach((thumb) => {
        const activate = () => this.activate(thumb);
        thumb.addEventListener('click', (event) => {
          event.preventDefault();
          activate();
        });
        if (hoverEnabled) {
          thumb.addEventListener('mouseenter', activate);
          thumb.addEventListener('focus', activate);
        }
      });
    }

    activate(thumb) {
      const src = thumb.getAttribute('data-hero-src');
      const srcset = thumb.getAttribute('data-hero-srcset');
      const blur = thumb.getAttribute('data-blur-src');
      if (src) this.heroImg.setAttribute('src', src);
      if (srcset) this.heroImg.setAttribute('srcset', srcset);
      if (this.blurImg && blur) this.blurImg.setAttribute('src', blur);

      this.thumbs.forEach((item) => {
        const isActive = item === thumb;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }
  }

  if (!customElements.get('machine-card-gallery')) {
    customElements.define('machine-card-gallery', MachineCardGallery);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["machine-module-videos"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const poster = event.target.closest('[data-video-embed]');
    if (!poster) return;
    const wrap = poster.closest('.prod-videos__embed-wrap');
    const url = poster.getAttribute('data-video-embed');
    if (!wrap || !url) return;
    const iframe = document.createElement('iframe');
    const joiner = url.includes('?') ? '&' : '?';
    iframe.src = url + joiner + 'autoplay=1';
    iframe.className = 'prod-videos__iframe';
    iframe.title = 'Product video';
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
    wrap.replaceChildren(iframe);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["machine-module-viewing"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-machine-viewing]');
    if (!button) return;
    let message = button.getAttribute('data-viewing-message');
    const modal = document.getElementById('machine-enquire');
    if (!modal || !message) return;
    try {
      message = JSON.parse(message);
    } catch (error) {
      // Use the attribute value as plain text
    }
    const decoder = document.createElement('textarea');
    decoder.innerHTML = message;
    message = decoder.value;
    const field = modal.querySelector('textarea[name="contact[body]"]');
    if (field) field.value = message;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["recommendations"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('complementary-products')) {
    class ComplementaryProducts extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('[data-complementary-toggle]');
        if (!this.toggle || this.toggle.dataset.bound) return;
        this.toggle.dataset.bound = 'true';
        this.toggle.addEventListener('click', this.onToggle.bind(this));
      }

      onToggle() {
        const collapsed = this.hasAttribute('data-collapsed');
        this.querySelectorAll('[data-complementary-extra]').forEach((item) => {
          item.hidden = !collapsed;
        });

        if (collapsed) {
          this.removeAttribute('data-collapsed');
          this.toggle.textContent = this.dataset.showLess;
          this.toggle.setAttribute('aria-expanded', 'true');
        } else {
          this.setAttribute('data-collapsed', '');
          this.toggle.textContent = this.dataset.showMore;
          this.toggle.setAttribute('aria-expanded', 'false');
        }
      }
    }

    customElements.define('complementary-products', ComplementaryProducts);
  }

  if (!customElements.get('complementary-multi-add')) {
    class ComplementaryMultiAdd extends HTMLElement {
      connectedCallback() {
        if (this.dataset.bound) return;
        this.dataset.bound = 'true';
        this.button = this.querySelector('[data-multi-add]');
        this.error = this.querySelector('[data-multi-error]');
        if (!this.button) return;

        this.addEventListener('change', (evt) => {
          if (evt.target.matches('[data-complementary-check]')) {
            this.justAdded = false;
            this.update();
          }
        });
        this.button.addEventListener('click', this.onAdd.bind(this));
        this.update();
      }

      /**
       * Ticked products that are currently visible (items hidden by Show more are ignored).
       * @returns {HTMLInputElement[]}
       */
      get selected() {
        return Array.from(this.querySelectorAll('[data-complementary-check]:checked'))
          .filter((input) => !input.closest('li')?.hidden);
      }

      update() {
        const count = this.selected.length;
        const template = this.dataset.mainForm ? this.dataset.labelMainCount : this.dataset.labelCount;
        this.button.disabled = count === 0;
        this.button.classList.toggle('is-added', Boolean(this.justAdded) && count === 0);

        if (this.justAdded && count === 0) {
          this.button.textContent = `\u2713 ${this.dataset.added}`;
        } else {
          this.button.textContent = count > 0
            ? template.replace('__COUNT__', count)
            : this.dataset.label;
        }
      }

      /**
       * Builds a cart line from the main product form (selected variant, quantity, properties).
       * @returns {object|null}
       */
      getMainItem() {
        const form = document.getElementById(this.dataset.mainForm);
        if (!form) return null;

        const formData = new FormData(form);
        const id = Number(formData.get('id'));
        if (!id) return { error: this.dataset.mainError };

        const item = { id, quantity: Number(formData.get('quantity')) || 1 };
        const sellingPlan = formData.get('selling_plan');
        if (sellingPlan) item.selling_plan = sellingPlan;

        const properties = {};
        formData.forEach((value, key) => {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match && value !== '') properties[match[1]] = value;
        });
        if (Object.keys(properties).length) item.properties = properties;

        return item;
      }

      showError(message) {
        if (!this.error) return;
        this.error.textContent = message || '';
        this.error.hidden = !message;
      }

      async onAdd() {
        const selected = this.selected;
        if (!selected.length || this.button.getAttribute('aria-disabled') === 'true') return;

        this.showError();

        const items = [];
        if (this.dataset.mainForm) {
          const mainItem = this.getMainItem();
          if (mainItem && mainItem.error) {
            this.showError(mainItem.error);
            return;
          }
          if (mainItem) items.push(mainItem);
        }
        selected.forEach((input) => items.push({ id: Number(input.dataset.variantId), quantity: 1 }));

        this.button.setAttribute('aria-disabled', 'true');
        this.button.classList.add('is-loading');

        const cartDrawer = document.querySelector('cart-drawer');
        let sections = 'cart-icon-bubble';
        if (cartDrawer) {
          sections += `,${cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
        }

        try {
          if (theme.settings.vibrateOnATC && window.navigator.vibrate) window.navigator.vibrate(100);

          const response = await fetch(theme.routes.cartAdd, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/javascript',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              items,
              sections,
              sections_url: window.location.pathname
            })
          });
          const data = await response.json();

          if (!response.ok) {
            throw new Error(data.description || data.message || response.status);
          }

          const bubble = document.getElementById('cart-icon-bubble');
          if (bubble && data.sections && data.sections['cart-icon-bubble']) {
            bubble.innerHTML = data.sections['cart-icon-bubble'];
          }

          if (cartDrawer && data.sections) {
            // Refresh the drawer contents quietly - don't open it.
            cartDrawer.renderContents(data, false);
          } else if (window.location.pathname === theme.routes.cart) {
            window.location.reload();
          }

          selected.forEach((input) => { input.checked = false; });
          this.justAdded = true;
          this.update();

          const cartResponse = await fetch(`${theme.routes.cart}.js`);
          if (cartResponse.ok) {
            this.dispatchEvent(new CustomEvent('on:cart:add', {
              bubbles: true,
              detail: { cart: await cartResponse.json() }
            }));
          }
        } catch (error) {
          this.showError(error.message);
        } finally {
          this.button.removeAttribute('aria-disabled');
          this.button.classList.remove('is-loading');
        }
      }
    }

    customElements.define('complementary-multi-add', ComplementaryMultiAdd);
  }

  if (!customElements.get('complementary-quick-view')) {
    class ComplementaryQuickView extends HTMLElement {
      connectedCallback() {
        if (this.dataset.bound) return;
        this.dataset.bound = 'true';
        this.dialog = this.querySelector('dialog');
        this.details = this.querySelector('.js-product-details');
        this.footer = this.querySelector('.js-footer-content');
        this.notice = this.querySelector('.js-added-to-cart');
        this.productUrl = '';

        this.querySelector('[data-close]').addEventListener('click', () => this.close());
        this.dialog.addEventListener('click', (evt) => {
          if (evt.target === this.dialog) this.close();
        });
        this.dialog.addEventListener('close', () => {
          if (this.notice) this.notice.hidden = true;
        });

        window.theme = window.theme || {};
        if (!window.theme.complementaryQuickView) {
          window.theme.complementaryQuickView = this;
          document.addEventListener('click', this.onDocumentClick.bind(this));
        }
      }

      onDocumentClick(evt) {
        const button = evt.target.closest('.js-complementary-view');
        if (!button || button.disabled) return;
        evt.preventDefault();
        const host = this.isConnected ? this : document.querySelector('complementary-quick-view');
        if (host) host.open(button);
      }

      close() {
        if (this.dialog.open) this.dialog.close();
      }

      addedToCart() {
        if (this.notice) this.notice.hidden = false;
      }

      async open(button) {
        const url = button.dataset.productUrl;
        if (!url || !this.dialog) return;

        if (this.notice) this.notice.hidden = true;

        if (this.productUrl === url && this.details.childElementCount > 0) {
          if (!this.dialog.open) this.dialog.showModal();
          return;
        }

        this.details.innerHTML = `<p>${this.dataset.loading}</p>`;
        this.footer.innerHTML = '';
        if (!this.dialog.open) this.dialog.showModal();

        try {
          const response = await fetch(url);
          if (!response.ok) throw new Error(response.status);

          const tmpl = document.createElement('template');
          tmpl.innerHTML = await response.text();
          const product = tmpl.content.getElementById('quick-buy-template')?.content.querySelector('.js-product');

          if (!product) {
            this.details.innerHTML = `<p><a class="link" href="${url}">${this.dataset.viewDetails}</a></p>`;
            this.productUrl = '';
            return;
          }

          if (window.theme.quickBuy && window.theme.quickBuy.convertToQuickBuyContent) {
            window.theme.quickBuy.convertToQuickBuyContent(product);
          }

          const details = product.querySelector('.js-product-details');
          const footer = product.querySelector('.js-footer-content');
          this.details.innerHTML = details ? details.innerHTML : '';
          this.footer.innerHTML = footer ? footer.innerHTML : '';
          this.productUrl = url;
        } catch {
          this.details.innerHTML = `<p><a class="link" href="${url}">${this.dataset.viewDetails}</a></p>`;
          this.productUrl = '';
        }
      }
    }

    customElements.define('complementary-quick-view', ComplementaryQuickView);
  }
  } catch(e) { console.error(e); }
})();

})();
